
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/merchant",
    icon: "android-menu",
    title: "专柜业务功能",
    component: Main,
    children: [
      {
        path: "account",
        title: "专柜账户管理",
        name: "MerchantAccount",
        component: resolve => {
          require(["@/views/merchantAccount/account.vue"], resolve);
        }
      },
      {
        path: "account/create",
        title: "创建专柜账户",
        name: "MerchantAccountCreate",
        component: resolve => {
          require(["@/views/merchantAccount/accountForm.vue"], resolve);
        }
      },
      {
        path: "account/edit/:id",
        title: "编辑专柜账户",
        name: "MerchantAccountEdit",
        component: resolve => {
          require(["@/views/merchantAccount/accountForm.vue"], resolve);
        }
      },
      {
        path: "account/approve",
        title: "专柜付款申请管理",
        name: "MerchantAccountPaymentApprove",
        component: resolve => {
          require(["@/views/merchantAccount/paymentApprove.vue"], resolve);
        }
      },
      {
        path: "account/approve/detail/:id",
        title: "专柜付款申请详情",
        name: "MerchantAccountPaymentApproveDetail",
        component: resolve => {
          require(["@/views/merchantAccount/paymentDetail.vue"], resolve);
        }
      },
      {
        path: "account/refund",
        title: "专柜退款申请管理",
        name: "MerchantAccountRefundApprove",
        component: resolve => {
          require(["@/views/merchantAccount/refundApprove.vue"], resolve);
        }
      },
      {
        path: "account/refund/detail/:id",
        title: "专柜退款详情",
        name: "MerchantAccountRefundApproveDetail",
        component: resolve => {
          require(["@/views/merchantAccount/refundDetail.vue"], resolve);
        }
      },
      {
        path: "taxRefundCompany",
        title: "退税公司管理",
        name: "MerchantTaxRefundCompany",
        component: resolve => {
          require(["@/views/merchantAccount/taxRefundCompany.vue"], resolve);
        }
      },
      {
        path: "goodsPool",
        title: "专柜商品池",
        name: "MerchantGoodsPool",
        component: resolve => {
          require(["@/views/merchantAccount/goods-pool.vue"], resolve);
        }
      },
      {
        path: "vendorBrand",
        title: "店铺对应品牌",
        name: "MerchantVendorBrand",
        component: resolve => {
          require(["@/views/merchantAccount/vendorBrand.vue"], resolve);
        }
      },
      {
        path: "taxRebateCommission",
        title: "退税公司佣金配置",
        name: "TaxRebateCommission",
        component: resolve => {
          require(["@/views/merchantAccount/taxRebateCommission.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
